import { createRouter, createWebHistory } from 'vue-router'

declare module 'vue-router' {
    interface RouteMeta {
        layout?:      'Public' | 'Blank'
        requiresAuth: boolean
    }
}

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition)         return savedPosition
        if (to.hash)               return { el: to.hash }
        if (from.path === to.path) return {}
        return { top: 0, behavior: 'smooth' }
    },
    routes: [
        {
            path:      '/',
            name:      'root',
            component: () => import('@/views/NotFound.vue'),
            meta:      { requiresAuth: false },
        },
        {
            path:      '/:slug',
            name:      'landing',
            component: () => import('@/views/Landing.vue'),
            meta:      { requiresAuth: false },
        },
        {
            path:      '/:slug/s/:serviceId',
            name:      'service',
            component: () => import('@/views/Service.vue'),
            meta:      { requiresAuth: false },
        },
        {
            path:      '/:slug/r/:code',
            name:      'manage',
            component: () => import('@/views/Manage.vue'),
            meta:      { requiresAuth: false },
        },
        {
            path:      '/:pathMatch(.*)*',
            name:      'not-found',
            component: () => import('@/views/NotFound.vue'),
            meta:      { requiresAuth: false },
        },
    ],
})

export default router
